import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { formatRp } from "@/lib/constants";

const idem = () => `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;

export const ObatMoney = ({ c, user, onDone }) => {
  const m = c.money || {};
  const role = user?.role;
  const isAdmin = role === "admin" || role === "super_admin";
  const run = async (path, body, msg) => {
    try { await api.post(path, { ...body, idem_key: idem() }); toast.success(msg); onDone(); }
    catch (e) { toast.error(apiError(e)); }
  };
  const pay = () => {
    const method = window.prompt(`Bayar penuh sisa ${formatRp(m.sisa)}. Metode (Tunai / Transfer / QRIS / Debit / Lainnya):`, "Tunai");
    if (method) run(`/pharmacy/charges/${c.id}/pay`, { method }, "Pembayaran obat dicatat");
  };
  const refund = () => {
    const amount = window.prompt(`Nominal refund (maks ${formatRp(m.bersih)}). Stok TIDAK kembali otomatis:`, String(m.bersih));
    if (!amount) return;
    const reason = window.prompt("Alasan refund (wajib):", "");
    const method = window.prompt("Metode pengembalian (Tunai / Transfer / QRIS / Debit / Lainnya):", "Tunai");
    if (reason && method) run(`/pharmacy/charges/${c.id}/refund`, { amount: Number(amount), reason, method }, "Refund obat dicatat");
  };
  const reverse = (t) => {
    const reason = window.prompt("Alasan koreksi salah catat (wajib):", "");
    if (reason) run(`/pharmacy/txns/${t.id}/reverse`, { reason }, "Pembayaran salah catat dibalik");
  };
  const reversed = new Set((c.txns || []).filter((t) => t.kind === "reversal").map((t) => t.ref_txn_id));
  const row = (label, v, id, neg) => <div className="flex justify-between"><span>{label}</span><span data-testid={`obat-${id}-${c.id}`}>{neg ? `-${formatRp(v || 0)}` : formatRp(v || 0)}</span></div>;
  return (
    <div className="mt-1 space-y-0.5 rounded-lg bg-white/70 p-2 text-[11px] text-slate-600" data-testid={`obat-money-${c.id}`}>
      <p className="font-semibold" data-testid={`detail-obat-status-${c.id}`}>{c.status === "Void" ? "Dibatalkan" : c.status === "Belum Diserahkan" ? "Belum diserahkan" : "Sudah diserahkan"} · {c.payment_status || "-"}{c.refund_required ? " · perlu refund" : ""}</p>
      {row("Tagihan obat", m.due, "due")}
      {row("Pembayaran diterima", m.diterima, "received")}
      {m.dibatalkan > 0 && row("Koreksi salah catat", m.dibatalkan, "reversed", true)}
      {row("Refund", m.refund || 0, "refund", true)}
      {row("Pembayaran bersih", m.bersih, "net")}
      {row("Sisa obat", m.sisa, "sisa")}
      {(c.txns || []).map((t) => (
        <div key={t.id} className="flex items-center justify-between text-[10px] text-slate-500" data-testid={`obat-txn-${t.id}`}>
          <span>{t.kind} · {t.method || "-"} · {formatRp(t.amount)} · {(t.at || "").slice(0, 16).replace("T", " ")}</span>
          {role === "super_admin" && (t.kind === "payment" || t.kind === "opening") && !reversed.has(t.id) && c.status === "Belum Diserahkan" && (
            <button data-testid={`obat-reverse-${t.id}`} onClick={() => reverse(t)} className="font-bold text-amber-700 underline">Koreksi</button>)}
        </div>
      ))}
      <div className="flex gap-1.5 pt-1">
        {c.status !== "Void" && m.sisa > 0 && (isAdmin || user?.can_manage_billing) && <button data-testid={`detail-obat-pay-${c.id}`} onClick={pay} className="rounded-full bg-[#DB2777] px-2.5 py-0.5 font-bold text-white">Catat Bayar Obat</button>}
        {isAdmin && m.bersih > 0 && <button data-testid={`detail-obat-refund-${c.id}`} onClick={refund} className="rounded-full border border-rose-300 px-2.5 py-0.5 font-bold text-rose-700">Refund Obat</button>}
      </div>
    </div>
  );
};
